import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  State,
  getAccountFlowStatistics,
  getActiveProfileInFlows,
  getCreatedFlowsByDays,
  getCreatedFlowsByMonths,
  getIsActiveProfileInFlowsLoading,
  getIsCreatedFlowsByDaysLoading,
  getIsCreatedFlowsByMonthsLoading,
  getIsActiveFlowsLoading,
  getActiveFlows,
} from '../../store/ma.reducer';
import {
  GetAccountFlowStatisticsAction,
  BootStrapAccountAction,
  GetCreatedFlowsByMonthsAction,
  GetActiveProfileInFlowsAction,
  GetCreatedFlowsByDaysAction,
  GetActiveFlowsAction,
} from '../../store/ma.actions';
import { Observable, combineLatest, BehaviorSubject } from 'rxjs';
import { GetAccountsResponse, BootstrapAccount } from '../../store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BootstrapModalComponent } from '../../components/bootstrap-modal/bootstrap-modal.component';
import { tap, map } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'ma-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  accountFlowStatistics$: Observable<GetAccountsResponse>;

  onIntervalChange$ = new BehaviorSubject<string>('days');

  isActiveProfileInFlowsLoading$ = this.store.pipe(
    select(getIsActiveProfileInFlowsLoading),
  );
  activeProfileInFlows$ = this.store.pipe(
    select(getActiveProfileInFlows),
    map((data) => ({
      labels: data.map((item) => moment(item.day).format('YYYY-MM-DD')),
      data: data.map((item) => +item.count),
    })),
  );

  isActiveFlowsLoading$ = this.store.pipe(select(getIsActiveFlowsLoading));
  activeFlows$ = this.store.pipe(
    select(getActiveFlows),
    map((data) => ({
      labels: data.map((item) => moment(item.date).format('YYYY-MM-DD')),
      data: data.map((item) => +item.activecount),
    })),
  );

  isCreatedFlowsByDaysLoading$ = this.store.pipe(
    select(getIsCreatedFlowsByDaysLoading),
  );
  createdFlowsByDays$ = this.store.pipe(
    select(getCreatedFlowsByDays),
    map((data) => ({
      labels: data.map((item) => moment(item.day).format('YYYY-MM-DD')),
      data: data.map((item) => +item.count),
    })),
  );

  isCreatedFlowsByMonthsLoading$ = this.store.pipe(
    select(getIsCreatedFlowsByMonthsLoading),
  );
  createdFlowsByMonths$ = this.store.pipe(
    select(getCreatedFlowsByMonths),
    map((data) => ({
      labels: data
        .map((_, index) => {
          return moment().subtract(index, 'M').startOf('month').format('MMMM');
        })
        .reverse(),
      data: data.map((item) => +item.count).reverse(),
    })),
  );

  createdFlowsOverTime$ = combineLatest([
    this.createdFlowsByDays$,
    this.createdFlowsByMonths$,
    this.onIntervalChange$,
  ]).pipe(
    map(([days, months, period]) => {
      return period === 'days' ? days : months;
    }),
  );

  constructor(
    private readonly store: Store<State>,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.store.dispatch(new GetAccountFlowStatisticsAction());
    this.store.dispatch(new GetCreatedFlowsByMonthsAction());
    this.store.dispatch(new GetCreatedFlowsByDaysAction());
    this.store.dispatch(new GetActiveProfileInFlowsAction());
    this.store.dispatch(new GetActiveFlowsAction(30));
    this.accountFlowStatistics$ = this.store.pipe(
      select(getAccountFlowStatistics),
    );
  }

  activeFlowsChange(days: number) {
    this.store.dispatch(new GetActiveFlowsAction(days));
  }

  bootstrap() {
    const modalRef = this.modalService.open(BootstrapModalComponent, {
      backdrop: 'static',
      keyboard: false,
    });
    (modalRef.componentInstance as BootstrapModalComponent).bootstrap$
      .pipe(
        tap((value: BootstrapAccount) => {
          this.store.dispatch(
            new BootStrapAccountAction({ accounts: [value] }),
          );
          modalRef.close();
        }),
      )
      .subscribe();
  }
}
